import { actions } from '../../../state/status';
import Alert from '../../elements/Alert';
import { connect } from 'react-redux';

const mapStateToProps = state => ({
  isOpen: state.shift.status.error
});

const mapDispatchToProps = dispatch => ({
  onClose: () => dispatch(actions.resetStatus())
});

const AlertComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(Alert);

export default AlertComponent;



// WEBPACK FOOTER //
// ./src/components/container/Alert/index.js